export function ElitePlansAllocationPreviewSkeleton() {
  return (
    <div
      className='mx-5 animate-pulse overflow-hidden rounded-3xl bg-white/80 p-5'
      aria-busy='true'
      aria-label='Loading allocation preview'
    >
      <div className='mx-auto h-4 w-40 rounded bg-[color:var(--ep-ink-muted)] opacity-25' />
      <div className='mx-auto mt-3 h-3 w-56 rounded bg-[color:var(--ep-ink-muted)] opacity-15' />
      <div className='mt-6 h-40 w-full rounded-2xl bg-[color:var(--ep-ink-muted)] opacity-15' />
      <div className='mt-5 space-y-3'>
        <div className='h-3 w-full rounded bg-[color:var(--ep-ink-muted)] opacity-20' />
        <div className='h-3 w-5/6 rounded bg-[color:var(--ep-ink-muted)] opacity-15' />
        <div className='h-3 w-4/6 rounded bg-[color:var(--ep-ink-muted)] opacity-15' />
      </div>
      <div className='mt-6 h-12 w-full rounded-xl bg-[color:var(--ep-ink-muted)] opacity-20' />
    </div>
  )
}
